import { element } from '../../../core/elements';
import Group from '../../../primitives/shape/Group';
import { useBarData } from '../providers/data';
import { BarGroupMarkLabels } from './bar-group-labels';
import { BarGroupMarks } from './bar-group-marks';
import { getBarGroups } from './mark-utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BarGroup = element(function BarGroup(_ref) {
  let {
    data,
    top,
    left,
    xScale,
    yScale,
    colorScale,
    groupScale,
    colorAccessor,
    groupAccessor,
    valueAccessor,
    xAccessor
  } = _ref;
  const barGroups = getBarGroups(data, groupScale, xScale, yScale, colorScale, groupAccessor, valueAccessor, colorAccessor, xAccessor);
  return /*#__PURE__*/_jsxs(Group, {
    top: top,
    left: left,
    children: [/*#__PURE__*/_jsx(BarGroupMarks, {
      barGroups: barGroups,
      roundedCorners: true
    }), /*#__PURE__*/_jsx(BarGroupMarkLabels, {
      barGroups: barGroups,
      hide: true
    })]
  });
});
export function BarMarkSlot() {
  const {
    data,
    xAccessor,
    yAccessor,
    colorAccessor,
    colorScale,
    groupScale,
    xScale,
    yScale
  } = useBarData();
  return /*#__PURE__*/_jsx(BarGroup, {
    data: data,
    groupScale: groupScale,
    xScale: xScale,
    yScale: yScale,
    colorScale: colorScale,
    xAccessor: xAccessor,
    valueAccessor: yAccessor,
    colorAccessor: colorAccessor,
    groupAccessor: colorAccessor
  });
}